import { PageType } from "__generated__/globalTypes";

import { AzureConfigurator } from "../../../../services/azure-configurator/azure-configurator";
import { DetailedPageType, CategoryPage } from "../types";
export const checkBruidFlag = (pageLocale: string, pageType?: DetailedPageType) => {
  let flag: boolean | undefined;

  switch (pageType) {
    case PageType.Pdp:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList
          ?.bloomreachBruidPdpSimilarItems?.enabled;
      break;
    case PageType.Rbp:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachBruidRbp
          ?.enabled;
      break;
    case PageType.SearchResults:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachBruidSrp
          ?.enabled;
      break;
    case CategoryPage.Plp:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachBruidPlp
          ?.enabled;
      break;
    case CategoryPage.Clp:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachBruidClp
          ?.enabled;
      break;
    default:
      flag =
        AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachBruid
          ?.enabled;
  }

  if (typeof flag !== "boolean") {
    flag =
      AzureConfigurator.getConfig(pageLocale)?.featureFlagList?.bloomreachBruid
        ?.enabled;
  }

  return flag;
};
